export default {
    props: {
        value: {
            type: [Object, Array],
            default: () => {}
        },

        placement: {
            type: String,
            default: 'right-start'
        },

        boundary: {
            default: 'viewport'
        },

        offset: {
            type: Number,
            default: 0
        },

        multiple: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            inited: false,

            loading: false,

            curRadioValue: this.value.id,

            selected: this.value
        };
    },

    computed: {
        checkConfirm() {
            return !!this.curRadioValue || this.selected.length;
        }
    },

    watch: {
        value(nextValue) {
            if (this.multiple) {
                this.selected = this.updateMultipleValue(nextValue);
            } else {
                this.curRadioValue = nextValue.id;
            }
        }
    },

    methods: {
        initData() {
            this.fetchData();
        },

        update() {
            this.$refs.popper.update();
        },

        updateMultipleValue(newValue) {
            const selected = [];
            if (!Array.isArray(newValue)) {
                // eslint-disable-next-line no-param-reassign
                newValue = [];
            }
            newValue.forEach(item => {
                selected.push(Number(item.id));
            });
            return selected;
        },

        show() {
            this.$refs.popper.show();
        },

        hide() {
            this.$refs.popper.hide();
        },

        bindTrigger(triggerElement, modeType = 'click', options = {}) {
            this.$refs.popper.bindTrigger(triggerElement, modeType, options);
        },

        setTrigger(triggerElement) {
            this.$refs.popper.setTrigger(triggerElement);
        },

        refresh() {
            this.fetchData();
        },

        cancel() {
            this.$refs.popper.hide();
        },

        onVisibleChange(value) {
            if (value && !this.inited) {
                this.initData();
            }
            if (this.multiple) {
                this.selected = this.updateMultipleValue(this.value);
            }
        }
    }
};
